{
  "top-salons-city-page": {
    "text": {
      "no-salon-found": "V tomto městě zatím nebyly nalezeny žádné salony."
    },
    "meta": {
      "title": "Nejlepší salony v {{ city }}",
      "description": "Objevte a rezervujte si nejlépe hodnocené kosmetické salony v {{ city }}. Porovnejte nejlepší salony, zkontrolujte dostupnost a rezervujte si termín online během pár minut."
    }
  }
}
